import { getField, updateField } from "vuex-map-fields";
import { client } from "@/api/client";
import { get_currentCompanyId } from "../../utils/common";
import { documents as api_documents } from "../../api";

const SET_DELETED_DOCUMENTS = "SET_DELETED_DOCUMENTS";
const SET_CURRENT_LOADING = "SET_CURRENT_LOADING";
const SET_ITEMS_PER_PAGE = "SET_ITEMS_PER_PAGE";
const SET_DOCUMENTS_LIST_ID = "SET_DOCUMENTS_LIST_ID";
const UNSELECT_DOCUMENTS = "UNSELECT_DOCUMENTS";
const SET_ITEMS_LENGTH = "SET_ITEMS_LENGTH";
const CLEAN_FILTERS = "CLEAN_FILTERS";
const SET_CURRENT_FILTERS = "SET_CURRENT_FILTERS";

const state = () => ({
  documents: [],
  selected: [],
  documentListActionGroups: {
    'download': 'Descargas',
  },
  documentListAction: [
    {
      id: "restaurar",
      name: "Restaurar",
      group: "btn",
    },
    {'id': 'download_doc', 'name': 'Documentos', 'group': 'download'},
    {'id': 'download_merged_docs', 'name': 'Libro en formato PDF', 'group': 'download'},
    {'id': 'download_excel', 'name': 'Excel', 'group': 'download'},

  ],
  documentListOptions: {},
  documentsListId: null,
  currentDocumentsItemsLength: 0,
  loading: false,
  itemsPerPage: 10,
  statesFilter: undefined,
  documentsListFilters: "",
  filtersData: {
    id: {
      name: "id",
      label: "Id",
      value: "",
    },
    kind: {
      name: "kind",
      label: "Tipo",
      values: [
        { name: "Proveedor", value: "in_invoice" },
        { name: "Cliente", value: "out_invoice" },
        // {name: 'Nómina', value: 'payroll'},
      ],
      multiple: false,
      value: "",
    },
    search__icontains: {
      name: "search__icontains",
      label: "Todos los campos",
      value: "",
    },
  },
});

const getters = {
  getField,
  deletedDocuments: (state) => state.documents,
  loading: (state) => state.loading,
  itemsPerPage: (state) => state.itemsPerPage,
  documentsListId: (state) => state.documentsListId,
  currentDocumentsItemsLength: (state) => state.currentDocumentsItemsLength,
  documentsListFilters: (state) => state.documentsListFilters,
};

const mutations = {
  updateField,
  ["SET_DELETED_DOCUMENTS"](state, documents) {
    state.documents = documents;
  },
  ["SET_CURRENT_LOADING"](state, { loading }) {
    state.loading = loading;
  },
  ["SET_ITEMS_PER_PAGE"](state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage;
  },
  ["SET_DOCUMENTS_LIST_ID"](state, documentsListId) {
    state.documentsListId = documentsListId;
  },
  ["UNSELECT_DOCUMENTS"](state) {
    state.selected = [];
  },
  ["SET_ITEMS_LENGTH"](state, { itemsLength }) {
    state.currentDocumentsItemsLength = itemsLength;
  },
  [CLEAN_FILTERS](state) {
    for (let i in state.filtersData) {
      state.filtersData[i].value = "";
    }
  },
  ["SET_CURRENT_FILTERS"](state, filts) {
    state.documentsListFilters = filts;
  },
};

const get_queryset_filters = (state, rootGetters, params) => {
  params["filters"] = state.documentsListFilters;

  if (state.statesFilter) {
    let states = "";
    for (let i in state.statesFilter) {
      states += state.statesFilter[i] + ",";
    }
    params["filters"] = params["filters"] + "&state__in=" + states.slice(0, -1);
  }
  return params;
};

const actions = {
  getDeletedDocuments: ({ commit }, company_db_id) => {
    return new Promise((resolve, reject) => {
      client
        .get("deleted_documents/?company_id=" + company_db_id)
        .then((response) => {
          commit(SET_DELETED_DOCUMENTS, response.data["results"]);
          resolve(response);
        })
        .catch((err) => {
          console.error(err);
          reject();
        });
    });
  },
  setCurrentLoading: ({ commit }, loading) => {
    commit(SET_CURRENT_LOADING, { loading });
  },
  setItemsPerPage: ({ commit }, itemsPerPage) => {
    commit(SET_ITEMS_PER_PAGE, itemsPerPage);
  },
  resetDeletedDocuments: async ({
    state,
    commit,
    dispatch,
    rootGetters,
    getters,
  }) => {
    let currentCompanyId = get_currentCompanyId({ rootGetters });

    if (currentCompanyId) {
      commit(UNSELECT_DOCUMENTS);
      commit(SET_CURRENT_LOADING, { loading: true });

      const { page, itemsPerPage, sortBy, sortDesc } =
        state.documentListOptions;

      const filters = getters.documentsListFilters;
      const documentsListId = getters.documentsListId;
      let sortField = undefined;
      let sortOrder = undefined;
      if (sortBy) {
        sortField = sortBy[0];
      }
      if (sortDesc) {
        sortOrder = sortDesc[0];
      }
      await dispatch("me/refreshUserData", "", { root: true });

      let qs = {
        page,
        itemsPerPage,
        filters,
        currentCompanyId,
        documentsListId,
        sortField,
        sortOrder,
      };
      let response = await api_documents.listDeletedDocuments(qs);
      let count = response.data.count;
      commit(SET_ITEMS_LENGTH, { itemsLength: count });
      commit(SET_DELETED_DOCUMENTS, response.data["results"]);
      commit(SET_CURRENT_LOADING, { loading: false });

      return response;
    }
    return false;
  },
  restoreDocuments: ({ state, rootGetters }, { send_filters, docs }) => {
    return new Promise((resolve, reject) => {
      let params = {};
      let currentCompanyId;
      if (rootGetters.getCurrentCompany) {
        currentCompanyId = rootGetters.getCurrentCompany.id;
      } else if (rootGetters["me/userData"].companydb) {
        currentCompanyId = rootGetters["me/userData"].companydb;
      }
      params["cdb"] = currentCompanyId;

      if (send_filters) {
        params = get_queryset_filters(state, rootGetters, params);
      } else {
        params["doc_ids"] = [];
        for (let i in docs) {
          params["doc_ids"].push(docs[i].id);
        }
      }
      client
        .post("restore_documents/", params)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getFilters: ({ commit, state, dispatch }, filts) => {
    // commit(SET_DOCUMENT_OPTIONS_PAGE, 1)
    commit(SET_CURRENT_FILTERS, filts);
    return true;
  },
  generateFilters: ({ state, dispatch }) => {
    let filts = "";
    for (let filter in state.filtersData) {
      if (state.filtersData[filter].value) {
        filts += "&" + filter + "=" + state.filtersData[filter].value;
      }
    }
    return dispatch("getFilters", filts);
  },
  cleanFilters: ({ commit, dispatch }) => {
    commit(CLEAN_FILTERS);
    return dispatch("getFilters", "");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
